export const msalConfig = {
  auth: {
    clientId: 'acdff60c-6d97-4888-bc6b-cb91113bb5ff',
    authority: 'https://login.microsoftonline.com/common',
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ['User.Read'],
};
